import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";

export default function Versions() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");

  useEffect(() => { api.get("/admin/versions", { params: { limit: 100 } }).then(({ data }) => setItems(data)); }, []);

  const restore = async (v) => {
    if (!window.confirm(`Restaurar versão de ${v.kind}:${v.ref_key} de ${new Date(v.created_at).toLocaleString()}?`)) return;
    await api.post(`/admin/versions/${v.id}/restore`);
    toast.success("Versão restaurada.");
  };

  const filtered = items.filter(v => !filter || `${v.kind} ${v.ref_key}`.toLowerCase().includes(filter.toLowerCase()));

  return (
    <div>
      <h1 className="font-display text-4xl mb-2">Histórico de versões</h1>
      <p className="text-sm text-neutral-500 mb-6">Cada alteração no CMS gera uma versão anterior. Você pode restaurar qualquer ponto.</p>
      <input value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filtrar por tipo ou id..." className="w-full max-w-sm border border-black/15 px-3 py-2 rounded text-sm mb-4" data-testid="versions-filter" />
      <div className="space-y-2" data-testid="versions-list">
        {filtered.map((v) => (
          <div key={v.id} className="flex items-center gap-3 border border-black/10 p-3 rounded">
            <div className="flex-1">
              <div className="text-sm font-semibold">{v.kind} · {v.ref_key}</div>
              <div className="text-xs text-neutral-500">{new Date(v.created_at).toLocaleString()} · {v.editor}</div>
            </div>
            <button onClick={() => restore(v)} className="text-xs border border-black/15 px-3 py-1.5 rounded hover:bg-accent-yellow"><RotateCcw className="w-3 h-3 inline mr-1" /> Restaurar</button>
          </div>
        ))}
        {!filtered.length && <div className="text-sm text-neutral-500 text-center py-12">Nenhuma versão registrada.</div>}
      </div>
    </div>
  );
}
